export default "__VITE_ASSET__CYh_nurq__"